import {
  get, post, update, get2, upload, download
} from './helpers'

export function resetAkun($data) {
  return post('/reset-akun', $data)
}
export function getDataUser($data) {
  return post('/rekomendasi/get-user', $data)
}
export function loginUser($data) {
  return post('/auth/login', $data)
}
export function loginPerekomendasi($data) {
  return post('/rekomendasi/login', $data)
}
export function getTokenRekomendasi(tokenWawancara) {
  return get(`/rekomendasi/token/${tokenWawancara}`)
}
export function getPertanyaanPerekomendasi(token) {
  return get(`/rekomendasi/pertanyaan-perekomendasi?token=${token}`)
}
export function simpanJawabanPerekomendasi($data) {
  return post('/rekomendasi/update-jawaban', $data)
}

export function exportRekapitulasiHasil($data) {
  return get2('/rekapitulasi-hasil', $data)
}



export function getDataUserWawancara($data) {
  return get('/wawancara/get-user', $data)
}
export function loginPewawancara($data) {
  return post('/wawancara/login', $data)
}
export function getPsikogram($data) {
  return get('/wawancara/psikogram', $data)
}
export function simpanPsikogram($data) {
  return post('/wawancara/psikogram/simpan', $data)
}



// API GENERAL
export function downloadFileDashboard(filename) {
  return download(`/general/dashboard/download/dokumen/${filename}`)
}
export function getUserDetail(uuid) {
  return get(`/general/user/detail?uuid=${uuid}`)
}
export function getUserDetailDashboard(uuid) {
  return get(`/general/user/detail?dashboard=true&uuid=${uuid}`)
}
export function uploadFoto(file, metadata, onUploadProgress) {
  return upload('/general/user/uploadfile', file, metadata, onUploadProgress)
}
export function ubahPassword($data) {
  return post('/general/user/password/update', $data)
}
export function getDetailHasilSidang(uuid) {
  return get(`/general/hasil-sidang/detail/${uuid}`)
}
export function updateCatatanHasilSidang($data) {
  return post('/general/hasil-sidang/catatan/update', $data)
}
export function updateJawabanPenilaianHasilSidang($data) {
  return post('/general/hasil-sidang/jawaban-penilaian/update', $data)
}
// END API GENERAL

//API ADMIN
export function activationUser($data) {
  return post('/admin/pengguna/activation', $data)
}
export function postPengguna($data) {
  return post('/admin/pengguna/post', $data)
}
export function downloadTemplatePeserta() {
  return download(`/import/download-template`)
}
export function downloadTemplateSoal() {
  return download(`/import/download-template-soal`)
}
export function uploadFileImportPeserta(file, metadata, onUploadProgress) {
  return upload('/import/simak-ui', file, metadata, onUploadProgress)
}
export function uploadFileImportSoal(file, metadata, onUploadProgress) {
  return upload('/import/soal', file, metadata, onUploadProgress)
}
export function postVerify($data) {
  return post('/account/verify', $data)
}
export function postResend($data) {
  return post('/account/resend-otp', $data)
}
export function postRegister($data) {
  return post('/account/register', $data)
}
export function postLupaPassword($data) {
  return post('/account/forgot', $data)
}
export function postResetPassword($data) {
  return post('/account/reset-password', $data)
}
export function updateStatusByAdmin($data) {
  return post('/admin/status-hasil-sidang/update', $data)
}
export function generateDosen($data) {
  return get('/admin/bulkRegisterFromDosen', $data)
}
export function getDetailJadwalSidang(uuid) {
  return get(`/admin/jadwal-sidang/detail?uuid=${uuid}`)
}
export function updateJadwalSidang($data) {
  return post('/admin/jadwal-sidang/update', $data)
}

export function exportRekapitulasiPengajuanSidang($data) {
  return get2('/admin/export-rekapitulasi-pengajuan-sidang', $data)
}
//END API ADMIN

// API MAHASISWA
export function postWaktuUjian($data) {
  return post('/mahasiswa/waktu-ujian/tambah', $data)
}
export function deleteWaktuUjian($data) {
  return post('/mahasiswa/waktu-ujian/delete', $data)
}
export function postPembimbing($data) {
  return post('/mahasiswa/pembimbing/tambah', $data)
}
export function deletePembimbing($data) {
  return post('/mahasiswa/pembimbing/delete', $data)
}
export function postPenguji($data) {
  return post('/mahasiswa/penguji/tambah', $data)
}
export function deletePenguji($data) {
  return post('/mahasiswa/penguji/delete', $data)
}
export function postBerkas() {
  return post('/mahasiswa/pengajuan-sidang/baru')
}
export function updateBerkas($data) {
  return update('/mahasiswa/pengajuan-sidang/update', $data)
}
export function getPengajuanSidangDetail(provinsiId) {
  return get(`/mahasiswa/pengajuan-sidang/detail/${provinsiId}`)
}
export function uploadFilePengajuan(file, metadata, onUploadProgress) {
  return upload('/mahasiswa/pengajuan-sidang/uploadfile', file, metadata, onUploadProgress)
}
export function downloadDokumen(filename) {
  return download(`/mahasiswa/pengajuan-sidang/download/dokumen/${filename}`)
}
export function deletePengajuanSidang(uuid) {
  return post(`/mahasiswa/pengajuan-sidang/delete/${uuid}`)
}
export function updateBerkasHasilSidang($data) {
  return update('/mahasiswa/berkas-hasil-sidang/update', $data)
}
export function postNotifUpdateBerkas($data) {
  return post('/mahasiswa/berkas-hasil-sidang/notification', $data)
}
export function uploadFileBerkasHasilSidang(file, metadata, onUploadProgress) {
  return upload('/mahasiswa/berkas-hasil-sidang/uploadfile', file, metadata, onUploadProgress)
}
export function downloadBerkasHasilSidang(filename) {
  return download(`/mahasiswa/berkas-hasil-sidang/download/dokumen/${filename}`)
}
export function downloadSuratTugas(filename) {
  return download(`/dekanat/surat-tugas/download/dokumen/${filename}`)
}
export function generateSKTMT($data) {
  return post(`/dekanat/sktmt/generate`, $data)
}
export function getSuratTugasPengujiTanpaNomor($data) {
  return get(`/dekanat/total/surat-tugas-penguji-tn`, $data)
}
export function postProsesNomorSuratTugasPenguji($data) {
  return post(`/dekanat/proses/surat-tugas-penguji-tn`, $data)
}
export function postProsesNomorSuratTugasPembimbing($data) {
  return post(`/dekanat/proses/surat-tugas-pembimbing-tn`, $data)
}
export function getSuratTugasPembimbingTanpaNomor($data) {
  return get(`/dekanat/total/surat-tugas-pembimbing-tn`, $data)
}

// END API MAHASISWA

// API PEMBIMBING
export function postTerimaBerkas($data) {
  return post('/pembimbing/terima-berkas', $data)
}
export function postTolakBerkas($data) {
  return post('/pembimbing/tolak-berkas', $data)
}
export function postMulaiSidang($data) {
  return post('/pembimbing/mulai-sidang', $data)
}
export function updateStatusHasilSidang($data) {
  return post('/pembimbing/status-hasil-sidang', $data)
}
export function postPermintaanPerubahanNilai($data) {
  return post('/pembimbing/perubahan-nilai', $data)
}
export function postTandaiSelesai($data) {
  return post('/pembimbing/selesai', $data)
}
export function updateBeritaAcara($data) {
  return post('/pembimbing/update-berita-acara', $data)
}
export function downloadBeritaAcara(filename) {
  return download(`/pembimbing/download/berita-acara/${filename}`)
}
export function buildBeritaAcara($data) {
  return post(`pembimbing/build/berita-acara`, $data)
}
export function simpanNoteBerkas($data) {
  return post(`pembimbing/note/berkas`, $data)
}
export function postBatalkanUjian($data) {
  return post(`pembimbing/batalkan-ujian`, $data)
}

// END API PEMBIMBING

export function getDetailPerubahanNilaiHasilSidang(uuid) {
  return get(`/kaprodi/perubahan-nilai/hasil-sidang/${uuid}`)
}
export function updatePerubahanNilai($data) {
  return post(`kaprodi/perubahan-nilai`, $data)
}

// MASTER DATA
export function getJenisKelamin() {
  return get('/general/master/jenis-kelamin')
}
export function getJurusan() {
  return get('/general/master/jurusan')
}
export function getJenjang() {
  return get('/general/master/jenjang')
}
export function getProdi() {
  return get('/general/master/prodi')
}
export function getPeminatan() {
  return get('/general/master/peminatan')
}
export function getProvinsi() {
  return get('/general/master/provinsi')
}
export function getKota(provinsiId) {
  return get(`/general/master/kota/${provinsiId}`)
}
export function getJenisSidang() {
  return get('/general/master/jenis-sidang')
}
export function getProsesPersidangan() {
  return get('/general/master/proses-persidangan')
}
export function getDosen() {
  return get('/general/master/dosen')
}
export function getRuangan() {
  return get('/general/master/ruangan')
}
export function getRole() {
  return get('/general/master/role')
}
export function getProgram() {
  return get('/general/master/program')
}
export function getWaktuUjian() {
  return get('/general/master/waktu-ujian')
}
export function getJawabanPersetujuan() {
  return get('/general/master/jawaban-persetujuan')
}
export function getStatusHasilSidang() {
  return get('/general/master/status-hasil-sidang')
}
export function getStatusPengajuanSidang() {
  return get('/general/master/status-pengajuan-sidang')
}
export function getStatusJadwalSidang() {
  return get('/general/master/status-jadwal-sidang')
}
export function getTotalDosenTanpaAkun() {
  return get('/general/master/dosen-tanpa-akun')
}
// END MASTER DATA

// SETTINGS
export function getSettingByKey(key) {
  return get(`/setting/${key}`)
}
// END SETTINGS


